import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Service Worker kaydı
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Canlı ortam için HTTPS kontrolü
    const isSecureContext = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
    
    if (!isSecureContext) {
      console.warn('[Service Worker] Service Worker requires HTTPS (or localhost). Current protocol:', window.location.protocol);
    }
    
    // Service Worker kayıt yolu - production'da root'tan, development'ta da root'tan
    const swPath = '/service-worker.js';
    
    navigator.serviceWorker.register(swPath, {
      scope: '/' // Service worker'ın tüm siteyi kapsaması için
    })
      .then((registration) => {
        
        // Service Worker'dan gelen mesajları dinle (ses çalma için)
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data && event.data.type === 'PLAY_NOTIFICATION_SOUND') {
            playNotificationSound();
          }
        });
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker && newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available, prompt user to refresh
              }
            });
          }
        });
        
        // Service Worker'ın aktif olmasını bekle
        if (registration.active) {
          // Service Worker aktif
        } else if (registration.installing) {
          const installingWorker = registration.installing;
          installingWorker.addEventListener('statechange', () => {
            // State değişti
          });
        } else if (registration.waiting) {
          // Service Worker bekliyor
        }
      })
      .catch((error) => {
        console.error('[Service Worker] Registration failed:', error);
        console.error('[Service Worker] Error details:', {
          message: error.message,
          stack: error.stack,
          protocol: window.location.protocol,
          hostname: window.location.hostname
        });
      });
  });
} else {
  console.warn('[Service Worker] Service Worker not supported in this browser');
}

// Bildirim sesi çalma fonksiyonu (global)
function playNotificationSound() {
  try {
    // Audio element oluştur
    const audio = new Audio('/not.wav');
    audio.volume = 0.7;
    audio.play().catch((error) => {
      console.log('Notification sound play error:', error);
      // Fallback: Web Audio API ile basit bir bip sesi
      playFallbackNotificationSound();
    });
  } catch (error) {
    console.log('Notification sound error:', error);
    playFallbackNotificationSound();
  }
}

// Fallback ses (Web Audio API ile)
function playFallbackNotificationSound() {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 800; // 800 Hz
    oscillator.type = 'sine';
    
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.2);
  } catch (error) {
    console.log('Fallback sound error:', error);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
